import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import { map } from 'lodash';

import Items from './Items';
import InvoicesService from '../../services/InvoicesService';
import Pagination from '../../components/Pagination/Pagination';


class TableView extends Component {
  constructor() {
    super();
    this.state = { totalPages: '' };
  }


  componentDidUpdate(prevProps) {
   if (this.props.location !== prevProps.location) {
     this.onRouteChanged();
   }
 }
 onRouteChanged() {
   const {rest, setInvoices} = this.props;
   InvoicesService.getInvoices(rest.computedMatch.params.page)
     .then((res) => {
       const totalPages = res.body.meta["total-pages"];
       setInvoices(res.body.data.invoices)
       this.setState({
         totalPages: totalPages,
       })
     }).catch(error => {
     console.log(error);
     });
  }
  getInvoicesToDispley(){
    const {rest, setInvoices} = this.props;
    InvoicesService.getInvoices(rest.computedMatch.params.page)
      .then((res) => {
        const totalPages = res.body.meta["total-pages"];
        setInvoices(res.body.data.invoices)
        this.setState({
          totalPages: totalPages,
        })
      }).catch(error => {
      console.log(error);
      });
  }

  render() {
    const { translate, rest, headers } = this.props;
  const header = map(headers,(head)=>{
    return(
      <div className="col-md-4 pull-md-3 col-lg-4 pull-lg-2 hidden-sm-down">{translate('number')}</div>
      )
    })
    return (
      <div id="bills">
        <h1 className="title">{translate('invoices')}</h1>
        <div className="row row-head" style={{ height: 65 }} >
          <div className="col-1 hidden-md-down"></div>
          <div className="col-md-3 col-lg-2 hidden-sm-down">date</div>
          {header}
          <div className="col-md-2 col-lg-3 hidden-sm-down"></div>
        </div>
      <Items/>
      {Pagination(this.props.totalPages,rest.computedMatch.params.page)}
      </div>
    )
  }
};

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    payment: state.User.paymentMethod,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setInvoices: (invoices) => {
      dispatch(
        {
          type: 'SET_INVOICES',
          invoices: invoices,
        },
      );
    },
  }
}

TableView = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(TableView);


export default withRouter(TableView);



// WEBPACK FOOTER //
// ./src/lib/tables/TableView.js